export const SIGNATURE_SIMULATOR_PROVIDER = "simulator" as const;

export type SignatureSimulatorProvider = typeof SIGNATURE_SIMULATOR_PROVIDER;

export function isSignatureSimulatorEnabled(): boolean {
  return (
    import.meta.env.DEV === true ||
    import.meta.env.VITE_ENV === "development"
  );
}

export function isSignatureSimulatorProvider(
  provider: string | undefined | null,
): provider is SignatureSimulatorProvider {
  return provider === SIGNATURE_SIMULATOR_PROVIDER;
}
